module.exports = __webpack_public_path__ + "media/images/map-trifold-1b27fd0c.svg";